import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import StarRating from '../../components/Form/StarRating';
import { errorMessage, hasError } from '../../utils/form';
import { getMaskedDisplayName } from './CustomerReviewCreate.helpers';
import styles from './CustomerReviewCreate.module.css';

const ReviewFields = ({
  disabled,
  displayNameError,
  onDisplayNameBlur,
  onDisplayNameChange,
  onRatingChange,
  onReviewTextChange,
  validationError,
  values,
}) => {
  const maskedDisplayName = getMaskedDisplayName(values.displayName);

  return (
    <div className={disabled ? styles.disabledSection : ''}>
      <FormGroup className={styles.fieldGroup}>
        <div className={styles.labelRow}>
          <Label for="customer-review-display-name" className="mb-0">Display Name</Label>
          <span className={styles.required}>Required</span>
        </div>
        <Input
          disabled={disabled}
          id="customer-review-display-name"
          invalid={Boolean(displayNameError) || hasError('display_name', validationError)}
          name="display_name"
          onBlur={onDisplayNameBlur}
          onChange={onDisplayNameChange}
          placeholder="Enter display name"
          value={values.displayName}
        />
        {displayNameError && <span className={styles.feedback}>{displayNameError}</span>}
        {!displayNameError && errorMessage('display_name', validationError)}
        {maskedDisplayName ? (
          <span className={styles.preview}>
            Will be stored and shown as <strong className={styles.maskedDisplayName}>{maskedDisplayName}</strong> — one word, 3–50 characters
          </span>
        ) : (
          <span className={styles.helpText}>One word, 3–50 characters</span>
        )}
      </FormGroup>

      <FormGroup className={styles.fieldGroup}>
        <div className={styles.labelRow}>
          <Label className="mb-0">Rating</Label>
          <span className={styles.required}>Required</span>
        </div>
        <div className={styles.ratingRow}>
          <StarRating disabled={disabled} onChange={onRatingChange} value={values.rating} />
          <span className={styles.ratingValue}>{values.rating} / 5</span>
        </div>
        {errorMessage('rating', validationError)}
      </FormGroup>

      <FormGroup className={styles.fieldGroup}>
        <Label for="customer-review-text">Review Text (optional)</Label>
        <Input
          className={styles.reviewText}
          disabled={disabled}
          id="customer-review-text"
          invalid={hasError('review_text', validationError)}
          name="review_text"
          onChange={onReviewTextChange}
          placeholder="Optional review text"
          type="textarea"
          value={values.reviewText}
        />
        {errorMessage('review_text', validationError)}
        <span className={styles.counter}>{values.reviewText.length} / 1000</span>
      </FormGroup>
    </div>
  );
};

ReviewFields.propTypes = {
  disabled: PropTypes.bool.isRequired,
  displayNameError: PropTypes.string.isRequired,
  onDisplayNameBlur: PropTypes.func.isRequired,
  onDisplayNameChange: PropTypes.func.isRequired,
  onRatingChange: PropTypes.func.isRequired,
  onReviewTextChange: PropTypes.func.isRequired,
  validationError: PropTypes.object,
  values: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    reviewText: PropTypes.string.isRequired,
  }).isRequired,
};

ReviewFields.defaultProps = {
  validationError: null,
};

export default ReviewFields;
